/* eslint-disable no-underscore-dangle */

// import type { AdobeSatellite } from './types';

const waitForSatellite = (
  timeoutMs = 15000,
  intervalMs = 100
) => new Promise((resolve, reject) => {
  const startedAt = Date.now();

  const timer = globalThis.setInterval(() => {
    if (globalThis._satellite?.track) {
      globalThis.clearInterval(timer);
      resolve(globalThis._satellite);

      return;
    }

    if (Date.now() - startedAt >= timeoutMs) {
      globalThis.clearInterval(timer);
      reject(new Error('window._satellite.track was not available'));
    }
  }, intervalMs);
});

export default waitForSatellite;
